import { rem } from 'polished';
import styled from 'styled-components';
import { hoverMediaQuery, mediaQueryWidth, noHoverMediaQuery } from '../../../common/breakpoints';
import { black, lightBlue, white } from '../../../common/colors';
import { safeBGImageUrl } from '../../../common/helpers/strings';
import { PromoBannerProps } from './PromoBanner.props';

const bannerHeightDesktopPx = 470;
const maxWidthWideImagePx = 575;
const maxWidthSquareImagePx = 475;
const promoDarkGrey = '#060606';

export const StyledPromoBanner = styled.div<Pick<PromoBannerProps, 'backgroundSrc' | 'invertColors'>>`
  padding: ${rem(40)} ${rem(20)};
  ${({ backgroundSrc }) => `background-image: ${safeBGImageUrl(backgroundSrc)};`}
  background-color: ${({ invertColors }) => (invertColors ? promoDarkGrey : white)};
  background-size: cover;
  text-align: center;
  color: ${({ invertColors }) => (invertColors ? white : black)};

  ${mediaQueryWidth({ min: 'mobile', max: 'tablet' })`
    padding: ${rem(60)} ${rem(50)};
  `}

  ${mediaQueryWidth({ min: 'tablet' })`
    display: flex;
    align-items: center;
    min-height: ${rem(bannerHeightDesktopPx)};
    padding: ${rem(40)} ${rem(50)};
    box-sizing: border-box;
  `}

  & + & {
    margin: ${rem(20)} 0 0 0;
  }
`;

export const StyledPBImageContainer = styled.div`
  display: inline-block;
  width: 100%;
  margin: 0 0 ${rem(30)} 0;
  padding: 0;
  box-sizing: border-box;
  vertical-align: middle;

  ${mediaQueryWidth({ min: 'tablet' })`
    width: 50%;
    margin: 0;
    padding: 0 ${rem(60)} 0 0;
  `}
`;

export const StyledPBImage = styled.img<Pick<PromoBannerProps, 'isImageWide'>>`
  width: ${({ isImageWide }) => (isImageWide ? '100%' : '60%')};
  max-width: ${({ isImageWide }) => (isImageWide ? maxWidthWideImagePx : maxWidthSquareImagePx)}px;
  max-width: max-content;
`;

export const StyledPBContentContainer = styled.div`
  display: inline-block;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  vertical-align: middle;

  ${mediaQueryWidth({ min: 'tablet' })`
    width: 50%;
  `}
`;

export const StyledPBContent = styled.section<Pick<PromoBannerProps, 'invertColors'>>`
  padding: 0 0 0 ${rem(15)};
  border-left: 2px solid ${({ invertColors }) => (invertColors ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)')};
  text-align: left;

  ${mediaQueryWidth({ min: 'mobile' })`
    padding: 0 0 0 ${rem(60)}};
  `}
`;

export const StyledPBContentHeader = styled.header``;

export const StyledPBContentLink = styled.a`
  display: inline-block;
  margin: 0 0 ${rem(20)} 0;
  color: inherit;

  & > :not(:last-child) {
    margin: 0 0 ${rem(4)} 0;
  }

  ${hoverMediaQuery} {
    &:hover {
      color: ${lightBlue};
    }
  }

  ${noHoverMediaQuery} {
    &:active {
      color: ${lightBlue};
    }
  }
`;

export const StyledPBContentSupertitle = styled.div`
  font-size: ${rem(12)};
  line-height: ${rem(15)};
  font-weight: 500;

  ${mediaQueryWidth({ min: 'mobile' })`
    font-size: ${rem(14)};
    line-height: ${rem(18)};
  `}
`;

export const StyledPBContentTitle = styled.h2`
  margin: 0;
  padding: 0;
  font-size: ${rem(25)};
  line-height: ${rem(30)};
  font-weight: 800;
  color: inherit;
  text-transform: uppercase;

  ${mediaQueryWidth({ min: 'mobile' })`
    font-size: ${rem(50)};
    line-height: ${rem(60)};
  `}
`;

export const StyledPBContentSubtitle = styled.div`
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  font-weight: 500;

  ${mediaQueryWidth({ min: 'mobile' })`
    font-size: ${rem(20)};
    line-height: ${rem(24)};
  `}
`;

export const StyledPBContentText = styled.div`
  margin: 0 0 ${rem(15)} 0;
  font-size: ${rem(12)};
  line-height: ${rem(15)};
  font-weight: 400;

  ${mediaQueryWidth({ min: 'mobile' })`
    font-size: ${rem(14)};
    line-height: ${rem(18)};
    margin: 0 0 ${rem(20)} 0;
  `}
`;
